<div [ngStyle]="ngStyleArray">
    <img *ngIf="imageId !== undefined && imageId !== null"
         [src]="hasError ? fallbackUrl : imageUrl"
         height="100%"
         (error)="onImageError()" />
</div>
